import { render, staticRenderFns } from "./anonimoFinalizaYPaga.vue?vue&type=template&id=b2162b70&"
import script from "./anonimoFinalizaYPaga.vue?vue&type=script&lang=js&"
export * from "./anonimoFinalizaYPaga.vue?vue&type=script&lang=js&"
import style0 from "./anonimoFinalizaYPaga.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports